var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"label":"","x-small-chip":"","color":_vm.stateColor,"text-color":"white"}},[_vm._v(" "+_vm._s(_vm.stateName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }